<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="pubitCssCls30"></p>
<p class="pubitCssCls30"><span class="pubitCssCls31"> </span></p>
</div>
<div class="pubitCssCls32">
<p class="pubitCssCls33"><span class="pubitCssCls14"> </span><span class="pubitCssCls14">    </span></p>
<p class="pubitCssCls34"><span class="pubitCssCls35">PART</span></p>
<p class="pubitCssCls34"><span class="pubitCssCls35">ONE</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?9fd14b32